import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'jubili-success-modal',
  templateUrl: './success-modal.component.html',
  styleUrls: ['./success-modal.component.scss']
})
export class SuccessModalComponent implements OnInit {

  constructor(
    private modalService: NgbModal
  ) { }
  @ViewChild("content") content: any;

  ngOnInit() {
  }
  show() {
    this.modalService.open(this.content);
    let timeout = setTimeout(() => {
      this.modalService.dismissAll();
    }, 2000);
  }
}
